package navigation.home.edititinerary

import navigation.home.allitinerary.AllItineraryScreenModel
import navigation.home.edititineraryservice.EditItineraryServiceScreenModel
import navigation.home.itineraryoverview.ItineraryOverviewScreenModel
import org.koin.core.module.dsl.factoryOf
import org.koin.dsl.module

val itineraryUiModule
    get() =
        module {

            factoryOf(::AllItineraryScreenModel)

            factoryOf(::EditItineraryScreenModel)

            factoryOf(::EditItineraryServiceScreenModel)

            factoryOf(::ItineraryOverviewScreenModel)
        }
